import apiClient from "./api-client";
import { handleApiError } from "./error-handler";
import { AuditLog } from "../models/AuditLog";

/**
 * Get audit logs for a specific entity
 * @param entityType Type of entity (e.g., "User", "Company")
 * @param entityId ID of the entity
 */
export const getEntityAuditLogs = async (entityType: string, entityId: number | string): Promise<AuditLog[]> => {
  try {
    const response = await apiClient.get(`/audit/entities/${entityType}/${entityId}`);
    return response.data;
  } catch (error) {
    throw handleApiError(error, "Failed to fetch entity audit logs");
  }
};

/**
 * Get audit logs for a specific user's activity
 * @param userId User ID
 * @param startDate Optional start date filter
 * @param endDate Optional end date filter
 */
export const getUserAuditLogs = async (
  userId: number | string,
  startDate?: Date,
  endDate?: Date
): Promise<AuditLog[]> => {
  try {
    const searchParams = new URLSearchParams();
    
    if (startDate) {
      searchParams.append("startDate", startDate.toISOString());
    }
    
    if (endDate) {
      searchParams.append("endDate", endDate.toISOString());
    }
    
    const queryString = searchParams.toString() ? `?${searchParams.toString()}` : "";
    const response = await apiClient.get(`/audit/users/${userId}${queryString}`);
    return response.data;
  } catch (error) {
    throw handleApiError(error, "Failed to fetch user audit logs");
  }
};